const $ = jQuery.noConflict();

const stepForm = {
	stepsWrapper: '.gf_page_steps',
	steps: '.gf_step',

	rotate() {
		$( '.gf_step_progress-wrapper' ).removeClass( 'loaded' );
		setTimeout( () => {
			this.setProgressBox();
		}, 100 );
	},

	setProgress() {
		const wrapper = $( this.stepsWrapper );
		const progress = $( '.gf_step_progress' );

		const first = $( this.steps ).filter( ( i, item ) => $( item ).hasClass( 'gf_step_first' ) );
		const active = $( this.steps ).filter( ( i, item ) => $( item ).hasClass( 'gf_step_active' ) );
		const firstOffset = first.find( '.gf_step_number' ).offset().left + first.find( '.gf_step_number' ).width();
		const activeOffset = active.find( '.gf_step_number' ).offset().left;

		const spaceBetween = activeOffset - firstOffset;

		if ( !wrapper.hasClass( 'scrolled' ) ) {
			wrapper.scrollLeft( $( '.gf_step.gf_step_active' ).position().left );
			wrapper.addClass( 'scrolled' );
		}

		progress.width( spaceBetween );
	},

	setProgressBox() {
		const progress = $( '.gf_step_progress-wrapper' );

		if ( !progress.hasClass( 'loaded' ) || window.matchMedia( '(min-width: 768px)' ).matches ) {
			const first = $( this.steps ).filter( ( i, item ) => $( item ).hasClass( 'gf_step_first' ) );
			const last = $( this.steps ).filter( ( i, item ) => $( item ).hasClass( 'gf_step_last' ) );

			const firstOffset = first.find( '.gf_step_number' ).offset().left + first.find( '.gf_step_number' ).width();
			const lastOffset = last.find( '.gf_step_number' ).offset().left;

			const beginPos = parseInt( first.find( '.gf_step_number' ).css( 'margin-left' ) ) + first.find( '.gf_step_number' ).width();
			const spaceBetween = lastOffset - firstOffset;

			progress.width( spaceBetween ).css( 'left', beginPos );
			progress.addClass( 'loaded' );
			this.setProgress();
		}
	},

	prepareHTML() {
		const wrapper = $( this.stepsWrapper );

		if ( wrapper.length ) {
			const progress = $( '<div />', {
				class: 'gf_step_progress-wrapper'
			} );
			const progressValue = $( '<div />', {
				class: 'gf_step_progress'
			} );

			$( '.gf_step_clear' ).remove();
			progressValue.appendTo( progress );
			wrapper.append( progress );

			this.setProgressBox();
			window.addEventListener( 'orientationchange', this.rotate );
		}
	},

	init() {
		this.prepareHTML();
	}
};

export default stepForm;